import React, {Component} from 'react';
import { connect } from 'react-redux';


import Addbox from "./../FeedContainer/Addbox";
import AddboxRight from "./../FeedContainer/AddboxRight";
import Media from "./Media";

class MediaContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        userImage     : '',
        userPercentage: 0,
        totalFriend   : 0,
        totalPost     : 0,
        urlImageId    : this.props.urlImageId
  
      };
    }
    componentDidMount() {
      
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
     
    }
    render() {
      return (
        <div className="content_block">
          <div className="content_area">
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area">
               <Addbox/>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area">
              {(this.props.currentUserDetails.membership != "GOLD") ?
                <AddboxRight />
                : null 
               }
            </div>
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 post_area">
               <Media urlImageId={this.state.urlImageId}/> 
            </div>
          </div>
        </div>
      );
    }
}

const mapStateToProps = state => {
 
  return {
    listOfFeed         : state.listfeed,
    currentUserDetails : state.login,
    
  }
}



export default connect(
  mapStateToProps
)(MediaContainer);

